import styled from "styled-components"

const ContentWrapper = styled.div`
  max-width: ${({ theme }) => theme.pageWidth};
  margin: 0 auto;
  padding: 0 1.375rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 3.375rem;
  }
`
export default ContentWrapper
